// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"428b4864","1009":"428b4864","6419":"428b4864","7395":"428b4864","7502":"428b4864","8801":"428b4864"}[chunkId] + ".chunk.css";
};